import React, { useState } from "react";
import Navigation from "../components/Navigation";
import Hero from "../components/Hero";
import HowItWorks from "../components/HowItWorks";
import Features from "../components/Features";
import TargetUsers from "../components/TargetUsers";
import UseCases from "../components/UseCases";
import BottomCTA from "../components/BottomCTA";
import Footer from "../components/Footer";
import EarlyAccessModal from "../components/EarlyAccessModal";
import useScrollAnimation from "../hooks/useScrollAnimation";
import { useSEO } from "../utils/seo";

const Home: React.FC = () => {
  const isVisible = useScrollAnimation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useSEO({
    title: "Alertaio - AI API Cost Monitoring & Real-Time Budget Alerts for OpenAI",
    description: "Monitor OpenAI and AI API costs in real-time. Get instant alerts to prevent overspending. Set budget limits and track usage for ChatGPT, GPT-4, and LLM APIs. Perfect for developers and startups.",
    keywords: "AI API cost monitoring, OpenAI cost alerts, AI spending alerts, GPT-4 cost tracking, ChatGPT API budget, LLM API monitoring, prevent AI overspending, OpenAI usage alerts, AI budget management, real-time cost alerts, API cost tracker",
    canonicalUrl: "https://alertaio.com/",
    type: "website"
  });

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-indigo-50">
      {/* Navigation */}
      <Navigation />
      
      {/* Hero Section - Contains only H1 on page */}
      <Hero onOpenModal={openModal} />

      <main>
        {/* How It Works - H2 */}
        <HowItWorks isVisible={isVisible["how-it-works"]} />

        {/* Features Section - H2 with H3 subheadings */}
        <Features isVisible={isVisible.features} />

        {/* Who It's For - H2 */}
        <TargetUsers isVisible={isVisible["target-users"]} />

        {/* Use Cases - H2 with H3 subheadings */}
        <UseCases isVisible={isVisible["use-cases"]} />

        {/* Final CTA - H2 */}
        <BottomCTA
          isVisible={isVisible["bottom-cta"]}
          onOpenModal={openModal}
        />
      </main>

      <Footer />
      <EarlyAccessModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
};

export default Home;
